import Vue from 'vue';

import './styles/quasar.styl';
import lang from 'quasar/lang/pt-br';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import {
  Dialog,
  Notify,
  Loading,
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QDate,
  QTime,
  QPopupProxy,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QImg,
  QInput,
  QTable,
  QTd,
  QTr,
  QCard,
  QForm,
  QSelect,
  QFooter,
  QSpinner,
  QTabs,
  QTab,
  QTabPanels,
  QTabPanel,
  QCheckbox,
  QRadio,
  QEditor,
  QExpansionItem,
  QSeparator,
  QBanner,
  QDialog,
  QCardSection,
  QCardActions,
  QMenu,
  QChip,
  QPageSticky,
  QBtnToggle,
  QBtnDropdown,
  QInfiniteScroll,
} from 'quasar';

export const quasarConfig = {
  config: {
  },
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QDate,
    QTime,
    QPopupProxy,
    QBtnDropdown,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QImg,
    QInput,
    QTable,
    QTd,
    QTr,
    QCard,
    QForm,
    QSelect,
    QFooter,
    QSpinner,
    QTabs,
    QTab,
    QTabPanels,
    QTabPanel,
    QCheckbox,
    QRadio,
    QEditor,
    QExpansionItem,
    QSeparator,
    QBanner,
    QDialog,
    QCardSection,
    QCardActions,
    QMenu,
    QChip,
    QPageSticky,
    QBtnToggle,
    QInfiniteScroll,
  },
  directives: {
  },
  plugins: {
    Notify,
    Dialog,
    Loading,
  },
  lang,
};

Notify.setDefaults({
  position: 'top',
  message: 'Infelizmente ocorreu um erro ao realizar a operação',
  timeout: 1500,
});

Vue.use(Quasar, quasarConfig);
